import { Box, Divider, Flex, Stack, Title } from '@mantine/core'
import { useMemo } from 'react'
import { useTranslate } from 'react-admin'
import { UserApiDTO } from '../../codegen/generated/Api.schemas'
import { LXNoData } from '../../components/LXNoData'
import { UsersHelper } from '../../helpers/Users.helper'
import { useUserStore } from '../../stores/useUserStore'
import { Forbidden } from '../Forbidden'
import { UserRolesCards } from './UserRolesCards'
import { UserScopes } from './UserScopes'

type InformationsUserProps = {
  user: UserApiDTO | undefined
}

export const InformationsUser = ({ user }: InformationsUserProps) => {
  const t = useTranslate()
  const userStore = useUserStore()

  const roleIds = useMemo(() => (user?.roles ?? []).map(r => r.id), [user?.roles])

  return (
    <Box>
      <Flex justify="flex-start" align="center" gap="sm">
        {UsersHelper.getDeactivatedUser(user, t('pages.users.userIsDisabled'), 33)}
        <Title>{user?.email}</Title>
      </Flex>
      <Divider mt="md" mb="xl" />
      <Stack gap="xl">
        <Box>
          <Title order={4} mb="xs">
            {t('pages.users.scope')}
          </Title>
          <UserScopes scopes={user?.scopes} readonly />
        </Box>
        <Box>
          <Title order={4} mb="xs">
            {t('pages.users.roles')}
          </Title>
          {userStore.isAuthorised('user_roles.read') ? (
            (user?.roles?.length ?? 0) > 0 ? (
              <UserRolesCards availableRoleIds={roleIds} readonly />
            ) : (
              <LXNoData ta="left" my="xs" />
            )
          ) : (
            <Forbidden permission="user_roles.read" />
          )}
        </Box>
      </Stack>
    </Box>
  )
}
